// milindawebstore.com
// export const BASE_DOMAIN = "89.116.21.72";

export const BASE_DOMAIN = window.VOIP_HOST;
export const BASE_PORT = window.VOIP_PORT;
